<template>
    <tr :class="{
        'background-danger': itemMovementBulk.status == 1
            && !itemMovementBulk.finished, 'background-success': itemMovementBulk.status == 2
                && !itemMovementBulk.finished, 'background-warning': itemMovementBulk.status == 3
                    && !itemMovementBulk.finished, 'background-finished': itemMovementBulk.finished
    }">
        <td>
            <span> {{ itemMovementBulk.productName }}</span>
            <div class="text-center tag-product-category" v-if="itemMovementBulk.categoryProductColor"
                :style="'background-color:' + itemMovementBulk.categoryProductColor">
                <span> {{ itemMovementBulk.categoryProductName }}</span>
            </div>
            <div v-else class="tag-product-category-no-color text-center">
                <span> {{ itemMovementBulk.categoryProductName }}</span>
            </div>
        </td>
        <td>
            <div class="div-margin">
                <InputTextEdit v-model="itemMovementBulk.description" :enter="update" />
            </div>
        </td>
        <td class="text-center">
            <div class="div-margin">
                <Button v-if="itemMovementBulk.patrimonyId" :_key="itemMovementBulk.id" color="white" title="Patrimônio"
                    backGroundColor="#00A2A7" classIcon="fas fa-box" size="small" :clicked="openPatrimonies" />
                <span v-else> {{ itemMovementBulk.productBarCode }}</span>
            </div>
        </td>
        <td class="text-center td-quantity">
            <div class="div-margin">
                <span>
                    <IncrementDecrement :disabled="loading"
                        v-if="!itemMovementBulk.patrimonyId && !itemMovementBulk.finished" :min="1"
                        v-model="itemMovementBulk.quantity" :changed="update" />
                    <span class="title-quantity" v-else>{{ itemMovementBulk.quantity }}</span>
                </span>
            </div>
        </td>
        <td class="text-center">
            <div class="div-margin" v-if="itemMovementBulk.rentsDistribution.length > 0">
                <Button :_key="itemMovementBulk.id" title="Distribuição" color="white" backGroundColor="#156EBE"
                    classIcon="fa-regular fa-chart-network" size="small" :clicked="openDistribution" />
            </div>
        </td>
        <td class="text-center">
            <div>
                <span v-if="itemMovementBulk.status == 1">
                    <div>
                        <i class="fa-solid fa-do-not-enter icon-movement-danger"></i>
                    </div>
                    <span class="link" @click="openError">Erro(s)</span>
                </span>
                <span v-if="itemMovementBulk.status == 3">
                    <div>
                        <i class="fa-solid fa-triangle-exclamation icon-movement-warning"></i>
                    </div>
                    <span class="link" @click="openError">Info(s)</span>
                </span>
                <span v-if="itemMovementBulk.status == 2">
                    <i class="fa-solid fa-circle-check icon-movement-success"></i>
                </span>
            </div>
        </td>
        <td class="text-right">
            <div v-if="!itemMovementBulk.finished && !itemMovementBulk.patrimonyId" class="div-margin">
                <Button :_key="'btnRemove' + itemMovementBulk.id" type="danger" classIcon="fa-solid fa-trash"
                    size="small" :clicked="remove" />
            </div>
        </td>
    </tr>
</template>

<script>

import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import IncrementDecrement from "@nixweb/nixloc-ui/src/component/forms/IncrementDecrement.vue";
import InputTextEdit from "@nixweb/nixloc-ui/src/component/forms/InputTextEdit.vue";

import { mapMutations } from "vuex";

export default {
    name: "ItemMovementBulkOutPut",
    props: ["itemMovementBulk", "loading"],
    components: {
        Button,
        IncrementDecrement,
        InputTextEdit
    },
    methods: {
        ...mapMutations("generic", ["addEvent", "removeLoading"]),
        openPatrimonies() {
            this.addEvent({ name: "openPatrimonies", data: this.itemMovementBulk.patrimonies, });
            this.removeLoading([this.itemMovementBulk.id]);
        },
        update() {
            let self = this;
            setTimeout(function () {
                self.addEvent({ name: "productBulkUpdate", data: self.itemMovementBulk, });
            }, 500);
        },
        remove() {
            this.addEvent({ name: "productBulkRemoved", data: this.itemMovementBulk, });
        },
        openError() {
            this.addEvent({ name: "openError", data: this.itemMovementBulk.messagesError, });
        },
        openDistribution() {
            this.addEvent({ name: "openDistribution", data: this.itemMovementBulk });
            this.removeLoading([this.itemMovementBulk.id]);
        }
    },
}
</script>

<style scoped>
.td-quantity {
    width: 120px;
}

.div-margin {
    margin-top: 8px;
}

.icon-movement-success {
    font-size: 18px;
    color: #1D9E1D;
    margin-top: 13px;
}

.icon-movement-finished {
    font-size: 18px;
    color: #1990FF;
    margin-top: 13px;
}

.icon-movement-danger {
    font-size: 18px;
    color: red;
}

.icon-movement-warning {
    font-size: 18px;
    color: orange;
}


.td-name {
    width: 200px;
}

.title-quantity {
    font-size: 15px;
}

.truncate-text {
    max-width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.background-danger {
    background-color: #FFE8E8;
}

.background-warning {
    background-color: #FFFBE6;
}

.background-success {
    background-color: #EBF8F4;
}

.background-finished {
    background-color: #E6F7FF;
}

.link {
    color: #3f529b;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
}
</style>